<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <div class="modal-title">
              <span></span>
            </div>
            <div class="close">
              <i class="fal fa-times fa-fw" @click="closeModal"></i>
            </div>
          </slot>
        </div>
        <div class="modal-body">
          <div class="result">
            <div class="msg">
              {{ msg }}
            </div>
          </div>
          <div class="btn-wrap">
            <button @click="closeModal">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="./../ModalCommon.css" scoped></style>
<style src="./layout.css" scoped></style>
<script>
/* eslint-disable */
export default {
  name: "findIdModal",
  components: {},
  data() {
    return {
      isComplete: true,
      naverMap: null,
    };
  },
  props: ["msg"],
  watch: {},
  methods: {
    closeModal() {
      this.$store.commit("popupModalSwitch", false);
    },
  },
  computed: {},
  created() {},
  mounted() {},
};
</script>
